<template>
  <div>
    <div class="demo-alignment">
      <vs-breadcrumb class="mt-0 mb-6"
      :items="items"
      separator=">>"
      ></vs-breadcrumb>
    </div>

    <vs-row>
      <div class="vx-col w-full">
        <PageHeader :displayable_links="['campaign_insights', 'campaign_tracking']" />
      </div>
    </vs-row>

    <EditCampaign v-if="campaign !== null" :campaign="campaign" />
  </div>
</template>

<script>
import PageHeader from '@/views/campaigns/components/PageHeader.vue'
import EditCampaign from './components/EditCampaign.vue'

import {get} from 'lodash'

export default {
  data () {
    return {
      items:[
        {
          title: 'Campaigns',
          active : false
        },
        {
          title: 'Edit Campaign',
          active: true
        }
      ],
      campaign: null
    }
  },
  created () {
    // clear old campaign, adset data
    window.initialCampaignData = {}
    this.$store.state.adsetsDomainsMinBidConfirmed = {}

    // fetch campaign data
    this.fetchCampaign()
  },
  components: {
    PageHeader,
    EditCampaign
  },
  methods: {
    async fetchCampaign () {
      try {
        const response = await window.axios.get(`/campaigns/${this.$route.params.id}`),
          payload = get(response, 'data.payload', {})
        if (payload.version !== 'v3') {
          alert('This campaign isn\'t applicable for editing in this dashboard version')
          return this.$router.go(-1)
        }
      
        // save initial campaign data
        this.campaign = payload
        window.initialCampaignData = JSON.parse(JSON.stringify(payload))
      } catch (error) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss">
.vs-breadcrumb--link {
  color: #378ccb !important;
  cursor: default;
  font-weight: 500 !important;
}

.vs-breadcrumb-text-primary {
  color: black !important;
  font-weight: 500 !important;
}

.separator {
  color: black;
  margin-top: -5px;
  font-weight: bold;
}
</style>
